import { useAppSelector } from "Components/Hooks/hooks";
import { GlobalImage } from "config/image";
import React, { useMemo } from "react";
import { Row, Col } from "reactstrap";
interface InvoiceFooterProp {
  colorName?: string;
}
const InvoiceFooter: React.FC<InvoiceFooterProp> = ({
  colorName = "primary",
}) => {
  const total = useAppSelector((state) => state?.item?.calculatedTotalItems);
  const configData = useAppSelector((stat) => stat.config.configData);
  const { user } = useAppSelector((state) => state?.auth);

  console.log("total", total);

  const summaryItems = useMemo(
    () => [
      { label: "Sub-total", amount: `£${total?.subTotal.toFixed(2)}` },
      { label: "Tax", amount: `£${total?.totalTax.toFixed(2)}` },
      { label: "Discount", amount: `£${total?.totalDiscount.toFixed(2)}` },
      total?.depositType && {
        label: `Deposit (${
          total?.depositType.charAt(0).toUpperCase() +
          total?.depositType.slice(1)
        })`,
        amount: `£${total?.totalDeposit.toFixed(2)}`,
      },
    ],
    [total],
  );

  return (
    <div className="mt-4 mb-5">
      <Row className="mb-4">
        {/* Left Section - Terms & Conditions */}
        <Col md="6" className="pe-4">
          <h6
            className={`fw-bold mb-2`}
            style={{
              color: colorName,
            }}
          >
            Terms & Conditions
          </h6>
          <p className="text-muted small mb-0" style={{ lineHeight: "1.6" }}>
            {configData?.quote_invoice_settings?.terms_and_conditions}
          </p>
        </Col>

        {/* Right Section - Summary */}
        <Col md="6" className="ps-4">
          <div className="d-flex flex-column gap-2">
            {summaryItems.map((item, index) => (
              <div key={index} className="d-flex justify-content-between">
                <span style={{ color: colorName }}>{item?.label || ""}</span>
                <span className="text-dark">{item?.amount || ""}</span>
              </div>
            ))}

            {/* Total Row */}
            <div className="d-flex justify-content-between py-2 border-top border-bottom">
              <span className={`fw-bold`} style={{ color: colorName }}>
                Total
              </span>
              <span className="fw-bold text-dark">
                {" "}
                £{total?.grandTotal.toFixed(2)}
              </span>
            </div>
          </div>
        </Col>
      </Row>

      {/* Bottom Message */}
      <Row>
        <Col className="text-center">
          <p className="text-muted small mb-0">
            Thank you for your business! Feel free to reach out if you have any
            questions regarding this invoice.
          </p>
        </Col>
      </Row>

      {/* Footer & Signature */}
      <div className="d-flex flex-column align-items-end mt-3 mb-3">
        <div className="mt-3">
          <img
            src={
              configData?.quote_invoice_settings?.signature ||
              GlobalImage.dummySignature
            }
            alt="signature"
            width={75}
            className="mb-1"
          />
        </div>
        <span
          className="text-black2D font-primary fs-14 fw-medium"
          style={{
            minWidth: 0,
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
          }}
        >
          {user?.name}
        </span>
      </div>
    </div>
  );
};

export default React.memo(InvoiceFooter);
